import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import SinPermisos from "./../../components/sinpermisos";
import CampanaAudiencia from "../CampanaAudiencia";

const Referidos = () => {

  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser')
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON)
      setUsers(user);
    }
  }, []);

  if (users.rol !== undefined) {
    if (users.rol === 'admin' || users.rol === 'cliente'){
      // Renderizamos exactamente la misma UI que campana-audiencia
      return (
        <CampanaAudiencia />
      );
    }
    else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  }
  else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Referidos;